import styled from 'styled-components';
import AdminMaster from '../../../Layout/admin/Master';
import { Link, useParams, useNavigate } from 'react-router-dom';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import { useFormik } from 'formik';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { OverlayTrigger, Toast, ToastContainer } from 'react-bootstrap';
import "../../../../src/assets/css/dashboard.css"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import Form from 'react-bootstrap/Form';
import { changeQueueReleaseStatus, clientJobHistory, exportJobMonitor, filterTotalQueueDetails, generateOutputFileSchema, generateOutputFileSchema835, generateOutputXmlFileSchema, getChangeJobTat, getUserlist, getUserManualAssign, resentOutputFileSchema, rejectJobApi, revertGeneratedJob, automationForceSubmit, automationJobForce, exportautomation, jobFileDownload, sendToAutomationJobMonitor } from '../../../Redux/qms/action';
import { AUTOMATION_JOB_MONITOR, QMS } from '../../../routeNames';
import moment from 'moment';
import { filterQueueDetailsAutomation, queueHoldUser, getXautoJobmonitorCounts, partnerDropdown } from '../../../Redux/qms/action';
import { BiHide, BiShow, BiExport, BiFile, BiReset, BiSearch, BiTimer, BiUserPlus, BiXCircle, BiDownload, BiRefresh } from 'react-icons/bi';
import { TbBoxMultiple } from 'react-icons/tb';
import { BsAlarm, BsChevronDown, BsClockHistory, BsEye, BsLayoutTextSidebarReverse } from 'react-icons/bs';
import { HiChevronDown } from 'react-icons/hi';
import { IoIosSwitch, IoMdCheckbox, IoIosSend } from 'react-icons/io';
import { TbGridDots, TbHandGrab } from 'react-icons/tb';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import DateRangePicker from 'rsuite/DateRangePicker';
import * as Yup from 'yup';
import { getAllClientDropdown, getPartnerWiseClientDropdown } from '../../../Redux/client/action';
import { getAllStaffs, getGroupsForClient } from '../../../Redux/clientGroup/action';
import { myWorkDataEntryReport } from '../../../Redux/reports/action';
import axiosInstance from '../../../axiosInstance';
import { EDIT_WORK } from '../../../routeNames';
import MyWorkDataEntryReportModal from '../../BootstrapModal/MyWorkDataEntryReportModal';
import { changeAllTitleFunction, setfiltrationHistoryBottomTab, downloadFile, converToStrDateForAPI, converToStrDateTimeForAPI } from '../Dashboard/functions';
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import { setHours, setMinutes, setSeconds, startOfYear, endOfYear } from 'date-fns';
import 'rsuite/dist/rsuite.min.css';
import addMonths from 'date-fns/addMonths';
import { Tooltip, Tooltip as CustomeToolTip } from '@mui/material';
import Swal from 'sweetalert2';
import { FaRegEye } from "react-icons/fa";

import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";
import DateTimePicker from './DateTimePicker';

import { GrRevert } from "react-icons/gr";
import PlbBulkUpladModal from './utils/PlbBulkUpladModal';
import { LuFileSymlink, LuFileInput, LuLayoutGrid, LuList } from "react-icons/lu";
import { HiCpuChip } from "react-icons/hi2";
import { LiaFileDownloadSolid } from "react-icons/lia";
import FileViewerModal from '../../common/FileViewerModal';
import SummarizedViewTable from './SummarizedViewTable';
import PartnerDropDown from '../../common/PartnerClientFacilityDropDown/PartnerDropDown';
import ClientDropDown from '../../common/PartnerClientFacilityDropDown/ClientDropDown';



const TextField = styled.input`
    height: 32px;
    width: 200px;
    &:hover {
        cursor: pointer;
    }
    `;
const tat_timeStatus = [
    { value: "1", label: '24' },
    { value: "2", label: '48' },
];

const FadeInContainer = styled.div`
  animation: viewSlideIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) backwards;
  --view-offset: ${({ $direction }) => ($direction === 'left' ? '-24px' : '24px')};
  @keyframes viewSlideIn {
    from {
      opacity: 0;
      transform: translateX(var(--view-offset));
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const ViewToggle = styled.div`
  position: relative;
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 38px;
  padding: 3px;
  border-radius: 12px;
  background: #eef4f7;
  border: 1px solid #d6e5ec;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
  isolation: isolate;

  .view-toggle-thumb {
    position: absolute;
    top: 3px;
    bottom: 3px;
    left: 3px;
    width: calc(50% - 3px);
    border-radius: 9px;
    background: linear-gradient(135deg, #6ba2b6, #4a8197);
    box-shadow: 0 4px 12px rgba(74, 129, 151, 0.35);
    transform: translateX(${({ $active }) => ($active === 'detailed' ? '100%' : '0')});
    transition: transform 0.35s cubic-bezier(0.65, 0, 0.35, 1);
    z-index: -1;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 100%;
    padding: 0 16px;
    border: none;
    background: transparent;
    border-radius: 9px;
    color: #4a8197;
    font-size: 0.85rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: color 0.25s ease;
  }

  button:hover:not(.active) {
    color: #2f6f86;
  }

  button:focus-visible {
    outline: 2px solid #6ba2b6;
    outline-offset: 2px;
  }

  button.active {
    color: #fff;
  }

  button svg {
    font-size: 1.05rem;
    transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  button.active svg {
    transform: scale(1.15);
  }

  @media (prefers-reduced-motion: reduce) {
    .view-toggle-thumb,
    button svg {
      transition: none;
    }
  }
`;
const queryParams = new URLSearchParams(window.location.search);

const AutomationJobMonitor = () => {

    // Alert links (?is_from_alerts=true) open straight into the detailed view
    const [viewMode, setViewMode] = useState(() =>
        new URLSearchParams(window.location.search).get('is_from_alerts') === 'true' ? 'detailed' : 'summarized'
    );
    const [searchTrigger, setSearchTrigger] = useState(0);
    // Filters applied to the summarized cards, kept apart from the detailed view's filters
    const [summaryFilters, setSummaryFilters] = useState({ partner: [], client: [] });
    // Last form values of each view, restored when switching back to that view
    const viewFormValuesRef = useRef({ summarized: null, detailed: null });

    const [inProcessQueuedCount, setInProcessQueuedCount] = useState({
        automation_inprocess: 0,
        queued_for_processing: 0,
    });
    const [isCountsLoading, setIsCountsLoading] = useState(false);
    const [cooldownTime, setCooldownTime] = useState(0);

    useEffect(() => {
        let interval = null;
        if (cooldownTime > 0) {
            interval = setInterval(() => {
                setCooldownTime((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [cooldownTime]);

    const handleReloadCounts = () => {
        setIsCountsLoading(true);
        setCooldownTime(60);
        getXautoJobmonitorCounts()((response) => {
            setInProcessQueuedCount(response?.data);
            setIsCountsLoading(false);
        });
    };
    const [grandTotal, setGrandTotal] = useState({
        isActive: false,
    });

    const [pageno, setPageNo] = useState(1);
    const [toaster, setToaster] = useState(null);
    const [tatDate, setTatDate] = useState('')
    const [tatTime, setTatTime] = useState('')
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [exportLoader, setExportLoader] = useState(false);
    const [fullexportLoader, setFullexportLoader] = useState(false);
    const [rerunLoader, setRerunLoader] = useState(false);
 const [showCheckView,setShowCheckView]=useState(false)
 const [urlsplittedfile,setUrlsplitedfile]=useState() 
    let { lockbox_file } = useParams();


    useEffect(() => {
        setIsCountsLoading(true);
        getXautoJobmonitorCounts()((response) => {
            setInProcessQueuedCount(response?.data);
            setIsCountsLoading(false);
        });
    }, []);


    const navigate = useNavigate();
    const handleSort = async (column, order) => {

        setSortColumn(column?.sort_key);
        setSortOrder(order);
        fetchQueueListing({page:pageno, limit, sort_order:order, sort_key:column.sort_key, ...searchedData});

    };



    const predefinedBottomRanges = [
        {
            label: 'Today',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
            placement: 'left'
        },
        {
            label: 'Yesterday',
            value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
            placement: 'left'
        },
        {
            label: 'This week',
            value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 7 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
            placement: 'left'
        },
        {
            label: 'Last 30 days',
            value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
            placement: 'left'
        },
        {
            label: 'This month',
            value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
            placement: 'left'
        },
        {
            label: 'Last month',
            value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
            placement: 'left'
        },
        {
            label: 'This year',
            value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
            placement: 'left'
        },
        {
            label: 'Last year',
            value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
            placement: 'left'
        },

        {
            label: 'Last week',
            closeOverlay: false,
            value: value => {
                const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
                ];
            },
            appearance: 'default'
        },
        {
            label: 'Next week',
            closeOverlay: false,
            value: value => {
                const [start = new Date()] = value || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
                ];
            },
            appearance: 'default'
        }
    ];
    /////////////////////////////////////////////////////////////////







    const handleResetCallFetch = async () => {
        queueformik.resetForm();

        if (viewMode === 'summarized') {
            setSummaryFilters({ partner: [], client: [] });
            setSearchTrigger(prev => prev + 1);
            return;
        }

        setPageNo(1);
        setSortColumn('');
        setSortOrder('asc');
        setfiltrationHistoryBottomTab('');
        setSelectedRows([]);
        setSelectedData([]);
        handleResetCheckBox();

        const initialValues = {
            filename: "",
            client: "",
            status: "",
            tat_status: "",
            deposit_date_range: [],
            job_id: '',
            internal_tat_range: [],
            lockbox_file_name: "",
            tat_time: "",
        };
        setSearchedData(initialValues);
    }

    // Save the current view's form values and load the target view's own (or the given) values
    const switchViewMode = (mode, nextValues) => {
        if (mode === viewMode && !nextValues) return;
        viewFormValuesRef.current[viewMode] = queueformik.values;
        const savedValues = viewFormValuesRef.current[mode] ?? queueformik.initialValues;
        // Summarized view shows the filters actually applied to its cards
        const restoredValues = mode === 'summarized'
            ? { ...savedValues, partner: summaryFilters.partner, client: summaryFilters.client }
            : savedValues;
        queueformik.setValues(nextValues ?? restoredValues);
        setViewMode(mode);
    }

    const getDetailedFormValues = () => viewMode === 'detailed'
        ? queueformik.values
        : (viewFormValuesRef.current.detailed ?? queueformik.initialValues);

    const [disableTotal, setDisableTotal] = useState(false)

    const handleExportJobMonitor = async (props) => {
        if (!exportLoader) {
            const is_from_alerts = queryParams.get('is_from_alerts') === 'true';
            setGrandTotal({ ...grandTotal, isActive: false })
            setExportLoader(true)
            setDisableTotal(true)

            let header_names = [];

            const headerMap = {
                deposit_date: 'DEPOSIT DATE',
                partner: 'PARTNER',
                client: 'CLIENT',
                facility: 'FACILITY',
                job_file_name: "JOB FILE NAME",
                job_id: "JOB ID",
                job_status: "JOB STATUS",
                lockbox_file_name: "LOCKBOX FILE NAME",
                internal_tat: "INTERNAL TAT",
                automation_start_time: "AUTOMATION START TIME",
                automation_end_time: "AUTOMATION END TIME",
                no_of_pages: "NO OF PAGES",
                comment: "COMMENT",
            };


            for (let key in headerMap) {
                if (state && state[key]) {
                    const headerName = headerMap[key];
                    if (headerName) {
                        header_names.push(headerName);
                    }
                }
            }

            let deposit_date = converToStrDateForAPI(props?.deposit_date_range)
            
            exportautomation({ ...props, deposit_date, header_names,is_from_alerts }, { is_download: true })((response) => {

                if (!response?.data?.status && response?.status) {
                    setExportLoader(false)

                    handleResetCheckBox()
                    setDisableTotal(false)
                    downloadFile(response?.data, 'automation-job-monitor')
                } else {
                    setExportLoader(false)

                    handleResetCheckBox()
                    setDisableTotal(false)
                    console.log("ERROR");
                }
            });
        }
    }


    const HandleExportAll = () => {
        if (!FullExportCheck) {

        } else {
            handleFullExportJobMonitor({ page: pageno, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData })
        }

    }


    const handleFullExportJobMonitor = async (props) => {
        if (!fullexportLoader) {
            setGrandTotal({ ...grandTotal, isActive: false })
            setDisableTotal(true)
            setFullexportLoader(true)
            let header_names = [];

            const headerMap = {
                deposit_date: 'DEPOSIT DATE',
                partner: 'PARTNER',
                client: 'CLIENT',
                facility: 'FACILITY',
                job_file_name: "JOB FILE NAME",
                job_id: "JOB ID",
                job_status: "JOB STATUS",
                lockbox_file_name: "LOCKBOX FILE NAME",
                internal_tat: "INTERNAL TAT",
                automation_start_time: "AUTOMATION START TIME",
                automation_end_time: "AUTOMATION END TIME",
                no_of_pages: "NO OF PAGES",
                comment: "COMMENT",
            };


            for (let key in headerMap) {
                if (state && state[key]) {
                    const headerName = headerMap[key];
                    if (headerName) {
                        header_names.push(headerName);
                    }
                }
            }

            let deposit_date = converToStrDateForAPI(props?.deposit_date_range)

            exportautomation({ ...props, deposit_date, header_names }, { is_download: true, all_data: true })((response) => {

                if (!response?.data?.status && response?.status) {
                    setFullexportLoader(false)
                    handleResetCheckBox()
                    setDisableTotal(false)
                    downloadFile(response?.data, 'automation-job-monitor')
                } else {
                    setFullexportLoader(false)
                    handleResetCheckBox()
                    setDisableTotal(false)
                    console.log("ERROR");
                }
            });
        }
    }


    const automationForceformik = useFormik({
        initialValues: {
            reason: "",
        },
        validationSchema: Yup.object().shape({
            reason: Yup.string()
                .required('Required'),

        }),
        onSubmit: (values, { setSubmitting, }) => {
            if (values.reason.replace(/\s/g, "") == '') {
                automationForceformik.setErrors({ ...automationForceformik.errors, 'reason': 'Required' })
                return
            }
            setSubmitting(true)
            automationJobForce(selectedRows, values.reason)((response) => {
                setLoading(true)
                if (response && response.status) {

                    fetchQueueListing({page:pageno, limit, sort_order:sortOrder, sort_key:sortColumn, ...searchedData});
                    setAutomationforce(false)
                    setSubmitting(false)
                    setToaster('success')
                    automationForceformik.resetForm();
                    setSelectedRows([])
                    setSelectedData([])
                    handleResetCheckBox()
                    if (response?.pending_message) {

                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: '#6ba2b6',
                            confirmButtonText: 'ok',
                            showCancelButton: false,
                            allowOutsideClick: false,
                            // showCancelButton: true, // Show Cancel button
                            cancelButtonText: 'No',
                            backdrop: true,
                            title: response?.pending_message,
                            customClass: {
                                title: 'swal-titleText fs-5'
                            }
                        })
                    }

                }
                else {
                    setSubmitting(false)
                    setToaster('error')
                    setSelectedRows([])
                    setSelectedData([])
                    automationForceformik.resetForm();
                    handleResetCheckBox()
                    setAutomationforce(false)
                }
                setLoading(false)
            });
        },
    });



    const formik = useFormik({
        initialValues: {
            assignedqueue: "",
            staff: "",
            qa_or_snipping: "3",
        },
        validationSchema: Yup.object().shape({
            staff: Yup.string()
                .required('Required'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            setGrandTotal({ ...grandTotal, isActive: false })
            __formSubmit(values, { setSubmitting, resetForm })
        },
    });
    const __formSubmit = (values, { setSubmitting, resetForm }) => {
        getUserManualAssign(values?.staff, values?.assignedqueue, values?.qa_or_snipping, values?.is_import_job_forcefully)((response) => {
            setShowModal(false);
            if (response && response.status) {
                setSubmitting(false)
                setToaster('success')
                fetchQueueListing({page:pageno, limit, sort_order:sortOrder, sort_key:sortColumn, ...searchedData});
                setSelectedRows([])
                resetForm()

                formik.setValues({
                    qa_or_snipping: "3",
                    assignedqueue: "",
                    staff: "",
                })
                handleResetCheckBox()
            }
            else if (response?.response?.status === 406) {
                asignerror(response?.response?.data.errors, 'assign_user')
                setSubmitting(false)
                setTogglePopup(false)
            }
            else {
                setSelectedRows([])
                setToaster('error')
                setSubmitting(false)
                resetForm()

                // const timer = setTimeout(() => {
                //     setToaster(false)
                // }, 2000);
                // return () => clearTimeout(timer);
                handleResetCheckBox()

            }

        });
    };


    /////////////////////////////////////////////////////////////


    const [showModal, setShowModal] = useState(false);

    const [state, setState] = useState({
        deposit_date: true,
        partner: true,
        client: true,
        facility: true,
        job_file_name: true,
        job_id: true,
        job_status: true,
        lockbox_file_name: true,
        internal_tat: true,
        automation_start_time: true,
        automation_end_time: true,
        no_of_pages: true,
        comment: true,
        action: true,

    });
    const [loading, setLoading] = useState(false);


    const [toggleHistoryPopup, setToggleHistoryPopup] = useState({
        isShow: false,
        job_id: null,
    });
    const [historyData, setHistoryData] = useState([]);

    const [toggleReportPopup, setToggleReportPopup] = useState(false);
    const [reportData, setReportData] = useState([]);


    const [totalRows, setTotalRows] = useState(100);
    const [limit, setLimit] = useState(100);
    const [selectedRows, setSelectedRows] = useState([]);
    const [colorRow, setColorRow] = React.useState({});
    const [data, setData] = useState({})

    const [isFocusedClient, setIsFocusedClient] = useState(false);
    const [isFocusedStatus, setIsFocusedStatus] = useState(false);
    const [automationforce, setAutomationforce] = useState(false);

    useEffect(() => {
        if (toaster) {
            const timer = setTimeout(() => {
                setToaster(false)
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [toaster])

    const handleClientJobHistory = (id) => {
        clientJobHistory(id)((response) => {
            if (response && response.status) {
                setHistoryData(response?.data)
                setToggleHistoryPopup({
                    isShow: true,
                    job_id: id
                })
            } else {
                setToaster("error")
                setToggleHistoryPopup({
                    isShow: false,
                    job_id: id
                })

            }
        })
    }


    const handleSingleReportDetails = async (log_id, status, isView = false) => {
        const name = status == 'Data Capture Completed' || status == 'Partial Save' ? 'View Work' : "View QA"
        const url = !isView ? toggleHistoryPopup.job_id + '?log_id=' + log_id : log_id
        let new_tab = {
            id: 0,
            route: `${window.location.origin}` + EDIT_WORK + url,
            // route: `${window.location.origin}` + EDIT_WORK + 1278 +'?log_id='+20208,
            label: name,
            prevTabs: [],
            isNewTab: false,
            title: name
        }
        // window.parent.localStorage.setItem('bbtabs', JSON.stringify(data))
        window.parent.localStorage.setItem('newTab', JSON.stringify(new_tab))

        parent.document.getElementById('bottom-tab-add').click()
    }


    const handleClickAutomationCount = (type) => {
        if(isCountsLoading || loading)return
        switchViewMode('detailed', {
            ...getDetailedFormValues(),
            status:type
        })
        setSearchedData({...searchedData,status:type})
        fetchQueueListing({page:1,limit, sort_order:sortOrder, sort_key:sortColumn, ...searchedData, status:type});
        // refresh counts too, but only when the Reload Counts button is enabled (not in cooldown)
        if (cooldownTime <= 0) handleReloadCounts()
    }

    // Summarized card click -> open the detailed view filtered by that card's client and job status
    const handleSummaryCardClick = (row, statuses) => {
        if (loading) return
        const client = row?.client_id != null ? [row.client_id] : [];
        const partner = row?.partner_id != null ? [row.partner_id] : [];

        // Start the detailed view from clean filters so only this client's jobs are listed
        const filter = { ...queueformik.initialValues, partner, client, status: statuses };
        switchViewMode('detailed', filter)
        setSearchedData(filter)
        setfiltrationHistoryBottomTab(JSON.stringify(filter))
        handleResetCheckBox()
        setSelectedRows([])
        setPageNo(1)
        fetchQueueListing({page:1, limit, sort_order:sortOrder, sort_key:sortColumn, ...filter});
    }


    const handleSerialNumber = (index) => {
        return pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1
    }

    const columns = useMemo(
        () => [
            {
                id: 'asdf',
                name: '',
                cell: (row) => <span style={{ position: 'absolute', right: '40px' }} > {row?.is_large_batch_job && !row?.is_sub_job && <TbBoxMultiple />}</span>
                ,
                width: "5px",
                compact: true,
                wrap: true,
                reorder: true,
                ignoreRowClick: false,

            },
            {
                id: 'id',
                name: 'S.NO',
                selector: (row, index) => handleSerialNumber(index),
                width: "30px",
                compact: true,
                wrap: true,
                reorder: true,
                ignoreRowClick: false,

            },
            {
                id: 'DEPOSIT DATE',
                name: 'DEPOSIT DATE',
                sort_key: "deposit_date",
                selector: row => moment(row?.deposit_date).format('M/DD/YY'),
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.deposit_date ? moment(row?.deposit_date).format('M/DD/YY') : ""}</span>,
                sortable: true,
                reorder: true,
                left: true,
                wrap: true,
                grow: 0.2,
                width: '82px',
                omit: !state.deposit_date,
            },

            {
                id: 'PARTNER',
                name: 'PARTNER',
                sort_key: "partner",
                selector: row => row?.partner,
                cell: (row) => <Tooltip disableInteractive title={row?.partner} placement='top' arrow>
                    <span className='text-truncate' onClick={() => handleRowClick(row)} onDoubleClick={(e) => { handleDblClickCopy(row?.partner); }}>{row?.partner}</span>
                </Tooltip>,
                sortable: true,
                wrap: true,
                grow: 0.1,
                reorder: true,
                omit: !state.partner,
                ignoreRowClick: false,

            },
            {
                id: 'CLIENT',
                name: 'CLIENT',
                sort_key: "client",
                selector: row => row?.client,
                cell: (row) => <Tooltip disableInteractive title={row?.client} placement='top' arrow>
                    <span className='text-truncate' onClick={() => handleRowClick(row)} onDoubleClick={(e) => { handleDblClickCopy(row?.client); }}>{row?.client}</span>
                </Tooltip>,
                sortable: true,
                wrap: true,
                grow: 0.1,
                reorder: true,
                omit: !state.client,
                ignoreRowClick: false,

            },
            {
                id: 'FACILITY',
                name: 'FACILITY',
                sort_key: "facility",
                selector: row => row?.facility,
                cell: (row, index) => <div>
                    {row?.facility &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap  text-truncate ' style={{ width: "120px" }}>
                            <Tooltip disableInteractive title={row?.facility} placement='top' arrow>
                                {row?.facility &&
                                    <span key={index} className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.facility)}>{row?.facility}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>
                ,
                sortable: true,
                reorder: true,
                left: true,
                wrap: true,
                width: "140px",
                grow: 0.1,
                omit: !state.facility,
            },
            {
                id: 'JOB FILE NAME',
                name: 'JOB FILE NAME',
                sort_key: "job_file_name",
                sortable: true,
                selector: row => row?.job_file_name,
                cell: (row) => <div className='d-flex flex-row align-items-center gap-2' onClick={() => handleRowClick(row)}>
                    {row?.job_file_name &&
                        <React.Fragment>
                            <div style={{ width: '120px' }}
                                onDoubleClick={(e) => { handleDblClickCopy(row?.job_file_name); }}
                                className='overflow-hidden d-flex flex-row  flex-wrap text-truncate' >
                                <Tooltip disableInteractive title={row?.job_file_name} placement='top' arrow>
                                    <span className='text-truncate' > {row?.job_file_name}</span>
                                </Tooltip>
                            </div>
                             <div
                                className='' >
                                 <div role="button" onClick={() => onButtonClick(row?.splited_file)} className=''>
                                                                    <FaRegEye/>
                                                               </div>   
                            </div>
                        </React.Fragment>
                    }
                </div>,
                width: '180px',
                left: true,
                wrap: true,
                reorder: true,
                grow: 1.3,
                omit: !state.job_file_name,
            },
            {
                id: 'JOB ID',
                name: 'JOB ID',
                sort_key: "job_id",
                selector: row => row?.job_id,
                cell: (row) =>
                    <span onClick={() => handleRowClick(row)} onDoubleClick={() => handleDblClickCopy(row?.job_id)}>
                        {row?.job_id}
                    </span>,
                sortable: true,
                wrap: true,
                width: "120px",
                reorder: true,
                omit: !state.job_id,


            },
            {
                id: 'JOB STATUS',
                name: 'JOB STATUS',
                sort_key: 'job_status',
                selector: row => row?.job_status,
                cell: (row) => <Tooltip disableInteractive title={row?.job_status} placement='top' arrow>
                    <span className='text-truncate' onClick={() => handleRowClick(row)}> {row?.job_status}</span>
                </Tooltip>,
                reorder: true,
                left: true,
                wrap: true,
                width: "130px",
                omit: !state.job_status,
            },

            {
                id: 'LOCKBOX FILE NAME',
                name: 'LOCKBOX FILE NAME',
                sort_key: "lockbox_file_name",
                sortable: true,
                selector: row => row?.lockbox_file_name,
                cell: (row) => <div className='d-flex flex-row gap-2' onClick={() => handleRowClick(row)}>
                    {row?.lockbox_file_name &&
                        <React.Fragment>

                            <div style={{ width: '120px' }} className='overflow-hidden d-flex flex-row  flex-wrap text-truncate'
                                onDoubleClick={() => handleDblClickCopy(row?.lockbox_file_name)}
                            >
                                <Tooltip disableInteractive title={row?.lockbox_file_name} placement='top' arrow>
                                    <span className='text-truncate'> {row?.lockbox_file_name}</span>
                                </Tooltip>
                            </div>
                            <div
                                className='' >

                            </div>
                        </React.Fragment>
                    }
                </div>,
                width: '140px',
                left: true,
                wrap: true,
                reorder: true,
                grow: 1.5,
                omit: !state.lockbox_file_name,
            },


            {
                id: 'INTERNAL TAT',
                name: 'INTERNAL TAT',
                sort_key: "internal_tat",
                selector: row => row?.internal_tat,
                cell: (row) => <span className='text-truncate' onClick={() => handleRowClick(row)}>{row.internal_tat ? moment(row.internal_tat).format('M/DD/YY, H:mm') : "---"}</span>,
                sortable: true,
                width: "100px",
                reorder: true,
                left: true,
                wrap: true,
                grow: 0.5,
                omit: !state.internal_tat,
            },
            {
                id: 'AUTOMATION START TIME',
                name: 'AUTOMATION START TIME',
                sort_key: "automation_start_time",
                selector: row => row?.automation_start_time,
                cell: (row) => <span className='text-truncate' onClick={() => handleRowClick(row)}>{row.automation_start_time ? moment(row.automation_start_time).format('M/DD/YY, H:mm') : "---"}</span>,
                sortable: true,
                width: "138px",
                reorder: true,
                left: true,
                wrap: true,
                grow: 0.5,
                omit: !state.automation_start_time,
            },
            {
                id: 'AUTOMATION END TIME',
                name: 'AUTOMATION END TIME',
                sort_key: "automation_end_time",
                selector: row => row?.automation_end_time,
                cell: (row) => <span className='text-truncate' onClick={() => handleRowClick(row)}>{row.automation_end_time ? moment(row.automation_end_time).format('M/DD/YY, H:mm') : "---"}</span>,
                sortable: true,
                width: "138px",
                reorder: true,
                left: true,
                wrap: true,
                grow: 0.5,
                omit: !state.automation_end_time,
            },
            {
                id: '# PAGES',
                name: '# PAGES',
                sort_key: "no_of_pages",
                selector: row => row?.no_of_pages,
                cell: (row) => <div className='text-end'> <span onClick={() => handleRowClick(row)}> {row?.no_of_pages}</span></div>,
                sortable: true,
                reorder: true,
                left: true,
                wrap: true,
                grow: 0.1,
                width: "58px",
                omit: !state.no_of_pages,
            },

            {
                id: 'COMMENT',
                name: 'COMMENT',
                sort_key: "comment",
                selector: row => row?.comment,
                cell: (row, index) => <div style={{ cursor: 'pointer' }}>
                    {row?.comment &&
                        <div onClick={() => handleRowClick(row)} className='overflow-hidden d-flex flex-row  flex-wrap text-truncate' style={{ width: '140px' }}>
                            <Tooltip disableInteractive title={row?.comment.toUpperCase()} placement='top' arrow>
                                {row?.comment &&
                                    <span style={{ cursor: 'pointer' }} key={index} className='text-truncate  text-uppercase' onDoubleClick={() => handleDblClickCopy(row?.comment)}>{row?.comment}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>,
                style: {
                    cursor: "pointer",
                },
                reorder: true,
                width: '140px',
                left: true,
                wrap: true,
                omit: !state.comment,
            },
            {
                id: 'action',
                name: 'Actions',
                width: '50px',
                reorder: true,
                cell: (row) =>
                    <React.Fragment>
                        {!row?.is_freeze &&
                            <div className="d-flex justify-content-center align-items-center gap-2 job-monitor-table-wrapper">
                                {row?.snippet_image && row?.snippet_image != '' ?
                                    <React.Fragment>
                                        <Tooltip disableInteractive title="Snippet Image" placement='top' arrow>
                                            <div className={''} style={{ fontSize: '1.5em' }}

                                                onClick={() => { handleFileDownload(row?.snippet_image) }}

                                            >
                                                <BiDownload color={"#000000"} />
                                            </div>
                                        </Tooltip>
                                    </React.Fragment>
                                    :
                                    <></>
                                }
                                {checkUserPermission('view_job_history') ?
                                    <React.Fragment>
                                        <Tooltip disableInteractive title='History' placement='top' arrow>
                                            <Link className='' style={{ fontSize: '1.5em' }} onClick={() => handleClientJobHistory(row.id)} >
                                                <BsClockHistory color={"#000000"} />
                                            </Link>
                                        </Tooltip>
                                    </React.Fragment>
                                    : <React.Fragment><div style={{ width: "14.688px" }}></div></React.Fragment>
                                }
                            </div>
                        }
                    </React.Fragment>
                ,
                right: true,
                omit: !state.action
            },

        ],

        [state, pageno, selectedRows],
    );

    const handleFileDownload = (file) => {
        const fileURL = file;
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'SamplePDF.pdf';
        alink.target = '_blank';
        alink.click();


    }


    const rowDisabledCriteria = (row) => {

        if (row.status == "rejected" && row.is_freeze) {
            return true
        }
        else if (row.is_large_batch_job && !row.is_sub_job && ['imported', 'assigned', 'inprocess', 'partial_save', 'output_completed'].includes(row.status)) {
            return true
        }
        else if (row.is_large_batch_job && row.is_sub_job && ['qa_review', 'qa_complete', 'output_generated', 'output_completed', 'snipping', 'snipping_assigned', 'snipping_inprocess', 'snipping_complete'].includes(row.status)) {
            return true
        }
        else if (row.status == 'imported'
            || row.status == 'assigned'
            || row.status == 'inprocess'
            || row.status == 'datacaptured'
            || row.status == "partial_save"
            || row.status == 'qa_review'
            || row.status == 'qa_inprocess'
            || row.status == "qa_complete"
            || row.status == "ready_to_output_generate"
            || row.status == "output_generated"
            || row.status == "hold"
            || row.status == "rejected") {

            return false;
        }

    }




    const fetchQueueListing = async (props={}) => {
        const {page,deposit_date_range,internal_tat_range} = props;
        setLoading(true);
        let deposit_date = converToStrDateForAPI(deposit_date_range)
        let internal_tat = converToStrDateTimeForAPI(internal_tat_range) 
        filterQueueDetailsAutomation({...props, deposit_date,internal_tat})((response) => {
            setLoading(true)
            if (!response?.data?.status && response?.status) {

                setData(response);
                setPageNo(page)
                setDefaultValues(response?.data?.results?.default_values);
                setTotalRows(response?.data?.count);
                setLoading(false);

            }
        });

    };


    const handlePageChange = page => {

        setPageNo(page)
        fetchQueueListing({page, limit, sort_order:sortOrder, sort_key:sortColumn, ...searchedData});

    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setGrandTotal({ ...grandTotal, isActive: false })


        fetchQueueListing({page:1,limit:newPerPage, sort_order:sortOrder, sort_key:sortColumn, ...searchedData});

        setPageNo(1)

        setLimit(newPerPage);


        handleResetCheckBox()


    };


    const [checking, setChecking] = useState(true)
    const [defaultValues, setDefaultValues] = useState({})


    useEffect(() => {
        if (queryParams.get('is_from_alerts') === 'true') {
            queueformik.setFieldValue('status', ['automation_failed']);
            setSearchedData(prev => ({
                ...prev,
                status: ['automation_failed'],
                is_from_alerts:true,
            }));
            fetchQueueListing({
                page:1,
                limit,
                sort_order:sortOrder,
                sort_key:sortColumn,
                ...searchedData,
                status:['automation_failed'],
                is_from_alerts:true, // is_from_alerts
            });
        }
    }, []);

     useEffect(() => {
        getAllClientDropdown({ isAutomation: true })((response) => {
            setClientList(response?.data)
        })
    }, []);

    const [partnerList, setPartnerList] = useState([]);
    useEffect(() => {
        partnerDropdown()((response) => {
            if (response?.status) setPartnerList(response?.data || []);
        })
    }, []);

    // Detailed API filters by client only, so a partner selection is sent as that partner's clients
    const resolvePartnerClients = (values) => new Promise((resolve) => {
        if (!values?.partner?.length || values?.client?.length) {
            resolve(values?.client);
            return;
        }
        getPartnerWiseClientDropdown(values.partner)((response) => {
            const clientIds = response?.status
                ? (response?.data?.clients || []).flatMap(group => group?.clients || []).map(client => client?.value)
                : [];
            resolve(clientIds);
        });
    }); 

    useEffect(() => {

        if (!!checking && defaultValues?.client) {

            setState({

                deposit_date: defaultValues?.deposit_date,
                partner: defaultValues?.partner,
                client: defaultValues?.client,
                facility: defaultValues?.facility,
                job_file_name: defaultValues?.job_file_name,
                job_id: defaultValues?.job_id,
                job_status: defaultValues?.job_status,
                lockbox_file_name: defaultValues?.lockbox_file_name,
                internal_tat: defaultValues?.internal_tat,
                automation_start_time: defaultValues?.automation_start_time ? defaultValues?.automation_start_time : true,
                automation_end_time: defaultValues?.automation_end_time ? defaultValues?.automation_end_time : true,
                no_of_pages: defaultValues?.no_of_pages,
                comment: defaultValues?.comment,
                action: true,


            })
            setChecking(false)
        }

    }, [defaultValues]);

    const handleDblClickCopy = async (filename) => {
        navigator.clipboard.writeText(filename)

    };

    const handleResetCheckBox = () => {
        setUnselectCheck(true)
        setTimeout(() => {
            setUnselectCheck(false)
        }, 200);
    }

    const jobfiledownload = (file) => {
        jobFileDownload(file)((response) => {
            if (!response?.data?.status && response?.status) {
                const fileURL = response?.data;
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'SamplePDF.pdf';
                alink.target = '_blank';
                alink.click();

            }
        });

    }


   const onButtonClick = (file) => {
        jobFileDownload(file)((response) => {
            if (!response?.data?.status && response?.status) {
                const fileURL = response?.data;
                  setUrlsplitedfile(fileURL)
       setShowCheckView(true)

            }
        });

    }

  useEffect(() => {
    const handleKeyDown = (event) => {
      
      if (event.key === "Escape") {
        setShowCheckView(false);
      }
    }
  
    document.addEventListener("keydown", handleKeyDown);
  
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  

    const [searchedData, setSearchedData] = useState({

        filename: "",
        partner: [],
        client: [],
        status: "",
        tat_status: "",
        deposit_date_range: [],
        job_id: '',
        internal_tat_range: [],
        lockbox_file_name: "",
        tat_time: "",
    });


    const queueformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            filename: "",
            partner: [],
            client: [],
            status: "",
            tat_status: "",
            deposit_date_range: [],
            job_id: '',
            internal_tat_range: [],
            lockbox_file_name: "",
            tat_time: "",
            partner: [],
        },

        onSubmit: async (values) => {
        if(queryParams.get('is_from_alerts') === 'true') {
            queryParams.delete('is_from_alerts');
            
        }
            setGrandTotal({ ...grandTotal, isActive: false })

            if (viewMode === 'summarized') {
                setSummaryFilters({
                    partner: values?.partner || [],
                    client: values?.client || []
                });
                setSearchTrigger(prev => prev + 1);
                handleResetCheckBox();
                return;
            }

            const client = await resolvePartnerClients(values);
            fetchQueueListing({page:1,limit, sort_order:sortOrder, sort_key:sortColumn, ...values, client});

            const filter = {
                filename: values?.filename ? values?.filename : "",
                partner: values?.partner ? values?.partner : [],
                client: client ? client : [],
                status: values?.status ? values?.status : "",
                tat_status: values?.tat_status ? values?.tat_status : "",
                deposit_date_range: values?.deposit_date_range,
                job_id: values?.job_id,
                is_from_alerts:false,
                internal_tat_range: values?.internal_tat_range,
                lockbox_file_name: values?.lockbox_file_name,
                tat_time: values?.tat_time,
            }
            let filterData = JSON.stringify(filter);
            setfiltrationHistoryBottomTab(filterData)

            setSearchedData(filter)
            handleResetCheckBox()
            setSelectedRows([])

        },
    });


    const jobids = queueformik?.values?.job_id?.length > 0
    const filename = queueformik?.values?.filename?.length > 0
    const client = queueformik?.values?.client?.length > 0
    const partner = queueformik?.values?.partner?.length > 0
    const tat_status = queueformik?.values?.tat_status?.length > 0
    const deposit_date_range = Array.isArray(queueformik?.values?.deposit_date_range) && queueformik.values.deposit_date_range.length > 0;
    const status = queueformik?.values?.status?.length > 0
    const internal_tat_range = Array.isArray(queueformik?.values?.internal_tat_range) && queueformik.values.internal_tat_range.length > 0;
    const lockbox_file_name = queueformik?.values?.lockbox_file_name?.length > 0;
    const tat_time = queueformik?.values?.tat_time?.length > 0;
    const FullExportCheck = jobids || filename || partner || client || tat_status || deposit_date_range || status || internal_tat_range || lockbox_file_name || tat_time;


    const [filterState, setFilterState] = useState([{
        staff: [],
        client: [],
        client_group: [],
    }])

    const handleOnDateTimeChange = ({ name, value }) => {

        queueformik.setValues({
            ...queueformik.values,
            [name]: value ?? "",
        })
    }
    const handleOnMultySelectChange = async (selected, name) => {
        let selectedIds = [];

        selected.map((option) => {
            selectedIds.push(option.value)
        })

        queueformik.setValues({ ...queueformik.values, [name]: selectedIds });


        setFilterState({
            ...filterState,
            [name]: selected
        })

    }

    const handleTatStatusChange = async (selected, name) => {
        queueformik.setValues({ ...queueformik.values, [name]: selected?.value ?? "" });
    }

    const handleStationChange = (selected, name) => {
        queueformik.setValues({ ...queueformik.values, [name]: selected?.value ?? "" })
    }

    const station_option = [
        { value: "1", label: "My Work" },
        { value: "2", label: "QA Review" },
        { value: "3", label: "Snipping" },

    ]

    const status_options = [
        { value: "automation_pending", label: 'Automation Pending' },
        { value: "automation_failed", label: 'Automation Failed' },
        { value: "automation_inprocess", label: 'Automation In Process (Xauto)' },
        { value: "queued_for_processing", label: 'Queued for Processing (Xtract)' },



    ];

    const [selectedData, setSelectedData] = useState([])
    const [unselectCheck, setUnselectCheck] = useState(false)
    const handleRowSelected = React.useCallback(state => {
        console.log(state);
        var ids = [];
        var datas = [];
        state.selectedRows.map((row, index) => {
            ids.push(row.id);
            datas.push(row);
        })
        setSelectedRows(ids);
        setSelectedData(datas)
    }, []);


    const checkUserPermission = (check) => {
        var permissions = JSON.parse(localStorage.getItem('permissions'))
        var data = permissions.find((element) => {
            return element == check;
        })
        if (data && data != undefined) {
            return true;
        }
        else {

            return false;
        }
    }


    const handleRowClick = (row) => {
        setColorRow(row);
    };

    const handleRowClickCheck = (row) => {

        data?.data?.results?.data.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
    }


    let i = 0;

    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.id == row.id ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
                color: 'black',
                fontWeight: '550',
                position: 'relative'
            }),
        },
        {
            when: row => row?.internal_tat_diff < 0 && row?.status !== "output_generated" && row?.status !== "output_completed",
            style: {
                backgroundColor: '#e89d9d',
                color: 'black',
                fontWeight: '550',
                position: 'relative'
            },
        },
        {
            when: row => colorRow.id == row.id && row?.internal_tat_diff < 0 && row?.status !== "output_generated" && row?.status !== "output_completed",
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row.id && row?.internal_tat_diff < 0 && row?.status !== "output_generated" && row?.status !== "output_completed" ? '#dbf4f5' : '#f2f2f2',
                color: 'black',
                fontWeight: '550',
                position: 'relative'
            }),
        },
        {
            when: row => row?.internal_tat_diff >= 0 && row?.internal_tat_diff <= 2 && row?.status !== "output_generated" && row?.status !== "output_completed",
            style: {
                backgroundColor: '#f4f475',
                color: 'black',
                fontWeight: '550',
                position: 'relative'
            },
        },
        {
            when: row => colorRow.id == row.id && row?.internal_tat_diff > 0 && row?.internal_tat_diff <= 2 && row?.status !== "output_generated" && row?.status !== "output_completed",
            style: (row, index) => ({
                backgroundColor: colorRow.id == row.id && row?.internal_tat_diff > 0 && row?.internal_tat_diff <= 2 ? '#dbf4f5' : '#f2f2f2',
                color: 'black',
                fontWeight: '550',
                position: 'relative'
            }),
        },
    ];


    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {filterState && filterState[state] && filterState[state].length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}



            </components.DropdownIndicator>
        );
    };



    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })

    const asignerror = (message = null) => {
        Swal.fire({
            icon: 'warning',
            confirmButtonColor: '#6ba2b6',
            confirmButtonText: 'Yes',
            showCloseButton: true,
            allowOutsideClick: false,
            cancelButtonText: 'No',
            showCancelButton: true,
            title: 'Warning',
            html: `<div class="fs-5">${message}</div>`,
            reverseButtons: true,
            customClass: {
                popup: 'custom-swal-popup'
            }
        })
            .then((result) => {

                if (result.isConfirmed) {
                    formik.setValues({ ...formik.values, is_import_job_forcefully: true });
                    formik.handleSubmit();
                }


                else if (result.isDismissed) {
                    formik.resetForm()
                }
            });
    };


    const handleSendToAutomation = () => {
        Swal.fire({
            icon: 'info',
            confirmButtonColor: '#6ba2b6',
            confirmButtonText: 'Yes',
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: 'No',
            backdrop: true,
            title: "Are You Sure",
            customClass: {
                title: 'swal-titleText fs-5'
            }
        }).then((result) => {
            if (result?.isConfirmed) {
                setRerunLoader(true)
                sendToAutomationJobMonitor(selectedRows)((response) => {
                    setRerunLoader(false)
                    if (response?.status) {
                        handleResetCheckBox()
                        fetchQueueListing({page:pageno, limit, sort_order:sortOrder, sort_key:sortColumn, ...searchedData});
                        setSelectedRows([])
                        setSelectedData([])
                    }
                    else if (response?.response?.status === 405) {
                        Swal.fire({
                            icon: 'warning',
                            confirmButtonColor: '#6ba2b6',
                            confirmButtonText: 'Ok',
                            showCloseButton: true,
                            allowOutsideClick: false,
                            title: 'Warning',
                            html: `<div class="fs-5">${response?.response?.data?.errors}</div>`,
                            customClass: {
                                popup: 'custom-swal-popup'
                            }
                        })
                        setSelectedRows([])
                        setSelectedData([])
                        handleResetCheckBox()
                    }
                });
            }
        })
    }


    const stylese = document.createElement("style");
    stylese.innerHTML = `
        .custom-swal-popup {
            padding-left: 20px !important;
            padding-right: 20px !important;
          
        }
    `;
    document.head.appendChild(stylese);


    const getSelectedValues = (list, item) => {
        return list?.filter((i) => item?.includes(i?.value))
    }

    const [showPlbModal, setShowPlbModal] = useState(false);
    const [currntJob, setCurrnJob] = useState(null)

    return (
        <React.Fragment>

            <AdminMaster ToastMessage={toaster} />




            <ToastContainer className="p-3" position={"top-end"}>
                <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                    {
                        status: false,
                        message: "",
                        type: "",
                    }

                )}
                    show={ToastMessage?.status} animation={true} delay={2000} autohide>
                    <Toast.Body ><span className='text-white'>{ToastMessage?.message}</span></Toast.Body>
                </Toast>

            </ToastContainer>


            <main id="main" className="main">


                <div className="pagetitle tab-fixed-header d-flex align-items-center flex-wrap gap-2">
                    <h1 id='page-title' className="m-0">Job Monitor-XAUTO</h1>
                    <div className='d-flex align-items-center ms-3'>
                        <div className='me-2'>
                            <CustomeToolTip disableInteractive placement='top' title={"Automation Inprocess (Xauto)"}>
                                <div onClick={()=>{handleClickAutomationCount(["automation_inprocess"])}} className={`badge-header jobMonitor-Buttons d-flex align-items-center justify-content-center  ${inProcessQueuedCount?.automation_inprocess > 0 ? ' red-text  header-red-border' : ' green-text  green-Border' }`} style={{ width: 'auto', minWidth: '45px', paddingLeft: '8px', paddingRight: '8px',cursor:'pointer' }} >
                                    <HiCpuChip />{' '}
                                    {isCountsLoading ? (
                                        <span className="spinner-border spinner-border-sm ps-1" role="status" style={{ borderWidth: '1.5px',fontSize:'large' }} />
                                    ) : (
                                        <span className='ps-1' style={{ fontSize:'large' }}>{inProcessQueuedCount?.automation_inprocess}</span>
                                    )}
                                </div>
                            </CustomeToolTip>
                        </div>

                        <div className='me-2'>
                            <CustomeToolTip disableInteractive placement='top' title={"Queued for processing (Xtract)"}>
                                <div onClick={()=>{handleClickAutomationCount(["queued_for_processing"])}} className={`badge-header jobMonitor-Buttons d-flex align-items-center justify-content-center  ${inProcessQueuedCount?.queued_for_processing > 0 ? ' red-text  header-red-border' : ' green-text  green-Border' }`} style={{ width: 'auto', minWidth: '45px', paddingLeft: '8px', paddingRight: '8px',cursor:'pointer' }} >
                                    <LuFileInput />{' '}
                                    {isCountsLoading ? (
                                        <span className="spinner-border spinner-border-sm ps-1" role="status" style={{ borderWidth: '1.5px',fontSize:'large' }} />
                                    ) : (
                                        <span className='ps-1' style={{ fontSize:'large' }}>{inProcessQueuedCount?.queued_for_processing}</span>
                                    )}
                                </div>
                            </CustomeToolTip>
                        </div>

                        <div>
                            <CustomeToolTip disableInteractive placement='top' title={cooldownTime > 0 ? `Retry in ${cooldownTime}s` : "Reload Counts"}>
                                 <span style={{ display: "inline-flex" }}>
                                <Button onClick={handleReloadCounts} disabled={isCountsLoading || cooldownTime > 0} className="btn btn-light btn-active-primary jobMonitor-Buttons " type="submit">
                                    <BiRefresh
                                        style={{
                                            fontSize: "1.25rem",
                                            animation: isCountsLoading ? "spin 1s linear infinite" : "none"
                                        }}
                                    />
                                </Button>
                                </span>
                            </CustomeToolTip>
                        </div>

                        <ViewToggle className="ms-3" role="tablist" aria-label="Job monitor view" $active={viewMode}>
                            <span className="view-toggle-thumb" aria-hidden="true" />
                            <button
                                type="button"
                                role="tab"
                                aria-selected={viewMode === 'summarized'}
                                className={viewMode === 'summarized' ? 'active' : ''}
                                onClick={() => switchViewMode('summarized')}
                            >
                                <LuLayoutGrid /> Summarized View
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={viewMode === 'detailed'}
                                className={viewMode === 'detailed' ? 'active' : ''}
                                onClick={() => switchViewMode('detailed')}
                            >
                                <LuList /> Detailed View
                            </button>
                        </ViewToggle>
                    </div>
                </div>
                <section className="section mt-5">



                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card  mb-xl-8 py-2">
                                <Form onSubmit={queueformik.handleSubmit}
                                    onReset={() => {
                                        handleResetCallFetch()
                                    }}
                                >

                                    <div style={{width:"100%", display: "flex", gap: "7px", marginLeft: "8px", flexWrap: 'wrap' }}>

                                        <PartnerDropDown lockboxformik={queueformik} width="230px" fontSize='14px' />
                                        <ClientDropDown lockboxformik={queueformik} width="230px" fontSize='14px' name="client" isPartner={false} /> 
                                         
                                        {viewMode === 'detailed' && (
                                            <>
                                                <div className=''>
                                                    <Select
                                                        tabSelectsValue={false}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={status_options}
                                                        className="select-search"
                                                        classNamePrefix="select"
                                                        components={{
                                                            DropdownIndicator: (props) => <DropdownIndicator {...props} state="status" />,
                                                            MultiValueLabel: (props) => (
                                                                <div title={props.data.label}>
                                                                    <components.MultiValueLabel {...props} />
                                                                </div>
                                                            ),
                                                        }}
                                                        placeholder="Status"
                                                        isClearable
                                                        // hideSelectedOptions={false}
                                                        name="status"
                                                        onFocus={() => setIsFocusedStatus(true)}
                                                        onBlur={() => setIsFocusedStatus(false)}
                                                        onChange={(e) => handleOnMultySelectChange(e, 'status')}
                                                        value={getSelectedValues(status_options, queueformik?.values?.status)}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            container: (styles, state) => ({
                                                                ...styles,
                                                                borderRadius: "9px",
                                                                width: "200px"
                                                            }),
                                                            control: (styles, state) => ({
                                                                ...styles,
                                                                backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                                borderStyle: "none", boxShadow: "none",
                                                                borderRadius: "10px",
                                                                maxHeight: state.isFocused ? "auto" : "30px",
                                                            }),
                                                            indicatorSeparator: styles => ({
                                                                ...styles, width: "0px",
                                                                minHeight: "20px",
                                                            }),


                                                            valueContainer: (styles, state) => ({
                                                                ...styles,
                                                                maxHeight: isFocusedStatus ? "auto" : "30px",
                                                            }),
                                                            // Wrap long status labels instead of truncating them with an ellipsis
                                                            multiValue: (styles) => ({
                                                                ...styles,
                                                                maxWidth: "100%",
                                                            }),
                                                            multiValueLabel: (styles) => ({
                                                                ...styles,
                                                                whiteSpace: "normal",
                                                                overflow: "visible",
                                                                wordBreak: "break-word",
                                                            }),
                                                            menuPortal: (styles) => ({
                                                                ...styles,
                                                                zIndex: 9999
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className=''>
                                                    <TextField
                                                        id="search"
                                                        className="form-control form-control-solid  b-r-10"
                                                        name='job_id'
                                                        type="search"
                                                        style={{ width: "100%" }}
                                                        placeholder="Job Id"
                                                        aria-label="Search Input"
                                                        value={queueformik.values?.job_id}
                                                        onChange={queueformik.handleChange}
                                                    />
                                                </div>
                                                <div style={{ width: "230px" }}>
                                                    <TextField
                                                        id="search"
                                                        className="form-control form-control-solid  b-r-10"
                                                        name='lockbox_file_name'
                                                        type="search"
                                                        style={{ width: "100%" }}
                                                        placeholder="Lockbox File Name"
                                                        aria-label="Search Input"
                                                        value={queueformik.values?.lockbox_file_name}
                                                        onChange={queueformik.handleChange}
                                                    />
                                                </div>
                                                <div style={{ width: "230px" }}>
                                                    <TextField
                                                        id="search"
                                                        className="form-control form-control-solid  b-r-10"
                                                        name='filename'
                                                        type="search"
                                                        style={{ width: "100%" }}
                                                        placeholder="File Name"
                                                        aria-label="Search Input"
                                                        value={queueformik.values?.filename}
                                                        onChange={queueformik.handleChange}
                                                    />
                                                </div>
                                                <div style={{ width: "145px" }}>
                                                    <Select
                                                        tabSelectsValue={false}
                                                        options={tat_timeStatus}
                                                        className="select-search"
                                                        classNamePrefix="select"
                                                        placeholder="TAT"
                                                        isClearable
                                                        name="tat_time"
                                                        onChange={(e) => handleTatStatusChange(e, 'tat_time')}
                                                        value={getSelectedValues(tat_timeStatus, queueformik?.values?.tat_time)}
                                                        menuPortalTarget={document.body}    
                                                        styles={{
                                                            container: (styles, state) => ({
                                                                ...styles,
                                                                borderRadius: "9px",
                                                            }),
                                                            control: (styles, state) => ({
                                                                ...styles,
                                                                backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                                borderStyle: "none", boxShadow: "none",
                                                                borderRadius: "10px",
                                                                maxHeight: state.isFocused ? "auto" : "30px",
                                                            }),
                                                            indicatorSeparator: styles => ({
                                                                ...styles, width: "0px",
                                                            }),

                                                            valueContainer: (styles, state) => ({
                                                                ...styles,
                                                                maxHeight: "30px",
                                                            }),
                                                            menuPortal: (styles) => ({
                                                                ...styles,
                                                                zIndex: 9999,
                                                            }),
                                                        }}
                                                    />
                                                </div>
                                               
                                                <Tooltip disableInteractive title={"Deposit Date"} placement="top" arrow>
                                                    <div className=''>
                                                        <Stack direction="column" spacing={8} alignItems="flex-start">
                                                           <DateRangePicker
                                                                ranges={predefinedBottomRanges}
                                                                cleanable={true}
                                                                appearance="subtle" // removes default blue behavior
                                                                format={"MM/dd/yyyy"}
                                                                placement="auto"
                                                                placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                                style={{
                                                                    border: FullExportCheck ? "1px solid #3498db" : "1px solid red", // blue when true, red when false
                                                                    borderRadius: "6px",
                                                                    boxShadow: "none",  // disables blue glow
                                                                    outline: "none",    // disables browser default
                                                                }}
                                                                name="deposit_date_range"
                                                                onChange={(e) => {
                                                                    handleOnDateTimeChange({ name: "deposit_date_range", value: e });
                                                                }}
                                                                value={queueformik?.values?.deposit_date_range}
                                                            />
                                                        </Stack>
                                                    </div>
                                                </Tooltip>
                                                {/* <Tooltip disableInteractive title={"Internal TAT"} placement="top" arrow>
                                                    <div className=''>
                                                        <Stack direction="column" spacing={8} alignItems="flex-start">
                                                           <DateRangePicker
                                                                ranges={predefinedBottomRanges}
                                                                cleanable={true}
                                                                defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                                appearance="default" 
                                                                format={"MM/dd/yyyy HH:mm"}
                                                                placement="auto"
                                                                placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                                name="internal_tat_range"
                                                                onChange={(e) => {
                                                                    handleOnDateTimeChange({ name: "internal_tat_range", value: e });
                                                                }}
                                                                value={queueformik?.values?.internal_tat_range}
                                                            />
                                                        </Stack>
                                                    </div>
                                                </Tooltip> */}
                                            </>
                                        )}

                                        

                                        <div style={{ display: "flex", gap: "6px" }}>
                                            <div>
                                                <Tooltip disableInteractive title="Search" placement='top' arrow>
                                                    <Button disabled={viewMode === 'detailed' && !FullExportCheck} className="btn btn-light btn-active-primary jobMonitor-Buttons " type="submit">
                                                        <span className="svg-icon svg-icon-3 ">
                                                            <BiSearch className='jobMonitor-svg' />
                                                        </span>

                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            <div>
                                                <Tooltip disableInteractive title="Reset" placement='top' arrow>
                                                    <Button className="btn btn-light btn-active-primary  jobMonitor-Buttons"
                                                        //onClick={handleResetCallFetch}
                                                        type="reset"
                                                    >
                                                        <span className="svg-icon svg-icon-3">
                                                            <BiReset className='jobMonitor-svg' />
                                                        </span>

                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            {viewMode === 'detailed' && (
                                                <>
                                                    <div>
                                                        <Tooltip disableInteractive title="Table Headings" placement='top' arrow>
                                                            <div className="dropdown">
                                                                <button className="btn btn-light btn-active-primary pb-2 dropdown-toggle  jobMonitor-Buttons" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <IoIosSwitch className='jobMonitor-svg' />
                                                                </button>
                                                                <ul className="dropdown-menu hide-scroll-bar" style={{ height: '500px', overflowX: 'scroll' }} onClick={(e) => e.stopPropagation()}>
                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.deposit_date} onChange={() => setState({ ...state, deposit_date: !state.deposit_date })} type="checkbox" id="deposit_date" />
                                                                                <label className="form-check-label" htmlFor="deposit_date">
                                                                                    Deposit Date
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.partner} onChange={() => setState({ ...state, partner: !state.partner })} type="checkbox" id="partner" />
                                                                                <label className="form-check-label" htmlFor="partner">
                                                                                    Partner
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                            <li>
                                                                <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.client} onChange={() => setState({ ...state, client: !state.client })} type="checkbox" id="client" />
                                                                                <label className="form-check-label" htmlFor="client">
                                                                                    Client
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.facility} onChange={() => setState({ ...state, facility: !state.facility })} type="checkbox" id="facility" />
                                                                                <label className="form-check-label" htmlFor="facility">
                                                                                    Facility
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.job_file_name} onChange={() => setState({ ...state, job_file_name: !state.job_file_name })} type="checkbox" id="job_file_name" />
                                                                                <label className="form-check-label" htmlFor="job_file_name">
                                                                                    Job File Name
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.job_id} onChange={() => setState({ ...state, job_id: !state.job_id })} type="checkbox" id="job" />
                                                                                <label className="form-check-label" htmlFor="job">
                                                                                    Job id
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.job_status} onChange={() => setState({ ...state, job_status: !state.job_status })} type="checkbox" id="job_status" />
                                                                                <label className="form-check-label" htmlFor="job_status">
                                                                                    Job Status
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.lockbox_file_name} onChange={() => setState({ ...state, lockbox_file_name: !state.lockbox_file_name })} type="checkbox" id="lockbox_file_name" />
                                                                                <label className="form-check-label" htmlFor="lockbox_file_name">
                                                                                    Lockbox File Name
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.internal_tat} onChange={() => setState({ ...state, internal_tat: !state.internal_tat })} type="checkbox" id="internal_tat" />
                                                                                <label className="form-check-label" htmlFor="internal_tat">
                                                                                    Internal Tat
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.automation_start_time} onChange={() => setState({ ...state, automation_start_time: !state.automation_start_time })} type="checkbox" id="automation_start_time" />
                                                                                <label className="form-check-label" htmlFor="automation_start_time">
                                                                                    Automation Start Time
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.automation_end_time} onChange={() => setState({ ...state, automation_end_time: !state.automation_end_time })} type="checkbox" id="automation_end_time" />
                                                                                <label className="form-check-label" htmlFor="automation_end_time">
                                                                                    Automation End Time
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>
                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.no_of_pages} onChange={() => setState({ ...state, no_of_pages: !state.no_of_pages })} type="checkbox" id="no_of_pages" />
                                                                                <label className="form-check-label" htmlFor="no_of_pages">
                                                                                    # Pages
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.comment} onChange={() => setState({ ...state, comment: !state.comment })} type="checkbox" id="comment" />
                                                                                <label className="form-check-label" htmlFor="comment">
                                                                                    Comment
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div className='dropdown-item'>

                                                                            <div className="form-check">
                                                                                <input className="form-check-input" checked={state.action} onChange={() => setState({ ...state, action: !state.action })} type="checkbox" id="action" />
                                                                                <label className="form-check-label" htmlFor="action">
                                                                                    Actions
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </li>

                                                                </ul>
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                    <Tooltip disableInteractive title="Export" placement='top' arrow>
                                                        <div className="dropdown">
                                                            <Button className="btn btn-light btn-active-primary pb-2 jobMonitor-Buttons" type="button" aria-expanded="false"
                                                                disabled={!FullExportCheck}
                                                              onClick={() => handleExportJobMonitor({page:pageno, limit, sort_order: sortOrder, sort_key: sortColumn, ...searchedData})}
                                                            >
                                                                {!exportLoader ?
                                                                    <BiExport className='jobMonitor-svg' /> :
                                                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                    </div>
                                                                }
                                                            </Button>
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip disableInteractive title="Export Full Data" placement='top' arrow>
                                                        <div className="dropdown">
                                                            <Button className="btn btn-light btn-active-primary pb-2 jobMonitor-Buttons" type="button" aria-expanded="false"
                                                                onClick={() => HandleExportAll()}
                                                                disabled={!FullExportCheck}
                                                            >
                                                                {!fullexportLoader ?
                                                                    <LiaFileDownloadSolid size={17} className='jobMonitor-svg' /> :
                                                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                    </div>
                                                                }
                                                            </Button>
                                                        </div>
                                                    </Tooltip>
                                                    {selectedRows?.length > 0 &&
                                                    <React.Fragment>
                                                        <div>
                                                            <Tooltip disableInteractive title="Forcefully Release" placement='top' arrow>
                                                                    <Button className='btn btn-light btn-active-primary  jobMonitor-Buttons'
                                                                    onClick={() => { setAutomationforce(true); }}
                                                                    disabled={selectedData?.some((el) => el?.job_status == "Automation Completed" || el?.job_status == "Forcefully Released" || el?.status == "Ready_to_process")}
                                                                >
                                                                    <LuFileSymlink />
                                                                </Button>
                                                            </Tooltip>
                                                        </div>
                                                        <div>
                                                            <Tooltip disableInteractive title="Rerun" placement='top' arrow>
                                                                <span>
                                                                    <Button className='btn btn-light btn-active-primary  jobMonitor-Buttons'
                                                                        onClick={() => { handleSendToAutomation() }}
                                                                        disabled={rerunLoader || !selectedData?.every((el) => el?.job_status === "Automation Failed")}
                                                                    >
                                                                        {!rerunLoader ?
                                                                            <IoIosSend className='jobMonitor-svg' /> :
                                                                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                                                            </div>
                                                                                }
                                                                    </Button>
                                                                </span>
                                                            </Tooltip>
                                                        </div>
                                                    </React.Fragment>
                                                    }
                                                </>
                                            )}
                                        </div>
                                    </div>

                                </Form>

                                <div className="ps-2">
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {viewMode === 'detailed' ? (
                                                !unselectCheck && (
                                                    <FadeInContainer key="detailed" $direction="right">
                                                        <DataTable
                                                            data={data?.data?.results?.data}
                                                            className="custom-datatable"
                                                            columns={columns}
                                                            progressPending={loading}
                                                            pagination

                                                            paginationServer
                                                            // highlightOnHover={true}
                                                            pointerOnHover={true}
                                                            fixedHeader={true}
                                                            selectableRows
                                                            // selectableRowsComponent={CustomSelectableRow}
                                                            onSelectedRowsChange={handleRowSelected}
                                                            // clearSelectedRows={true}
                                                            // sort={{ column: sortColumn, order: sortOrder }}
                                                            // onSort={handleSort}

                                                            // striped={true}
                                                            paginationTotalRows={totalRows}
                                                            paginationPerPage={limit}
                                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                                            onChangeRowsPerPage={handlePerRowsChange}
                                                            onChangePage={handlePageChange}
                                                            selectableRowDisabled={rowDisabledCriteria}
                                                            // subHeaderComponent={subHeaderComponentMemo}
                                                            theme="solarized"
                                                            customStyles={queueDatatableCustomStyles}
                                                            conditionalRowStyles={conditionalRowStyles}
                                                            // striped={true}
                                                            onRowClicked={handleRowClickCheck}
                                                            //onRowDoubleClicked={handleRowDoubleClick}
                                                            sortServer
                                                            onSort={handleSort}
                                                            // selectableRows 
                                                            responsive={true}
                                                            customFooter

                                                        />
                                                    </FadeInContainer>
                                                )
                                            ) : (
                                                <FadeInContainer key="summarized" $direction="left">
                                                    <SummarizedViewTable
                                                        clientFilter={summaryFilters.client}
                                                        partnerFilter={summaryFilters.partner}
                                                        searchTrigger={searchTrigger}
                                                        onCardClick={handleSummaryCardClick}
                                                    />
                                                </FadeInContainer>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Manual Release  Modal Starts*/}


                {/* Manual Modal  Modal Ends*/}
                {/* Manual History  Modal Starts*/}

                <Modal size="xl" show={toggleHistoryPopup.isShow} onHide={() => { setToggleHistoryPopup({ isShow: false, job_id: null }), setHistoryData([]) }} centered className='manual-tat'>
                    <Modal.Header closeButton>
                        <Modal.Title>Logs</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="table history-log-table" >
                            <thead>
                                <tr >
                                    <th >Date</th>
                                    <th >Created By</th>
                                    <th >Action</th>
                                    <th >Staff</th>
                                    <th >Comment</th>
                                    <th ></th>
                                    <th >Payload</th>
                                </tr>
                            </thead>
                            {historyData?.map((i, index) =>
                                <tbody key={index}>
                                    <tr >
                                        <td>{i.created_date ? i.created_date : ""}</td>
                                        <td><div className='text-truncate' style={{ width: "150px" }}>{i.created_by}</div></td>
                                        <td>{i.job_status}</td>
                                        <td><div className='text-truncate' style={{ width: "150px" }}>{i.staff}</div></td>
                                        <td className='text-break text-uppercase'>{i.comment}</td>
                                        {i.job_status == "Partial Save" || i.job_status == "QA Completed" || i.job_status == "Data Capture Completed" ?
                                            <td className='text-break'>
                                                <button type="button" onClick={() => {
                                                    handleSingleReportDetails(i.log_id, i.job_status)
                                                }
                                                } className='btn btn-light btn-active-primary btn-sm btn-icon'>
                                                    <i className='bi bi-eye fs-7'></i>
                                                </button>
                                            </td>
                                            :
                                            <td ></td>
                                        }
                                        <td>
                                            {i?.payload &&
                                                <Tooltip disableInteractive title="Download Payload" placement='top' arrow>
                                                    <div style={{ fontSize: '1.5em', cursor: 'pointer' }}
                                                        onClick={() => { handleFileDownload(i?.payload) }}
                                                    >
                                                        <span className='icon-style'>
                                                            <i className='bi bi-download'></i>
                                                        </span>
                                                    </div>
                                                </Tooltip>
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>

                    </Modal.Body>

                </Modal>

                {/* Manual Modal  Modal Ends*/}

                {/* Hold  Modal Starts*/}


                {/* <Modal show={toggleHoldPopup} onHide={() => { setToggleHoldPopup(false); holdFormik.resetForm() }} centered className='manual-tat'>
                    <Modal.Header closeButton>
                        <Modal.Title> Please Provide The Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={holdFormik.handleSubmit}>
                            <div className=''>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Reason</Form.Label>
                                    <Form.Control
                                        name='reason'
                                        type="text"
                                        autoComplete="false"
                                        // isValid={holdFormik.touched?.reason && !holdFormik.errors?.reason}
                                        isInvalid={!!holdFormik.errors?.reason}
                                        value={holdFormik.values?.reason}
                                        className='b-r-10 form-control-solid'
                                        onChange={holdFormik.handleChange}
                                        // onBlur={holdFormik.handleBlur}
                                        // 
                                        placeholder="Reason"
                                    />
                                    <Form.Control.Feedback type="invalid">{holdFormik.errors?.reason}</Form.Control.Feedback>
                                </Form.Group>

                            </div>
                            <div className='d-flex flex-row justify-content-center'>
                                <Button disabled={holdFormik.isSubmitting} type="submit" className='btn btn-light btn-active-primary' variant="primary" >Submit</Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal> */}
                {/* Hold Modal Ends*/}

                {/* Manual TAT  Modal Starts*/}


                {/* <Modal show={show} onHide={handleClose} centered className='manual-tat'>
                    <Modal.Header closeButton>
                        <Modal.Title> Change TAT</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={formik.handleSubmit}>
                            <div className=''>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Current TAT</Form.Label>
                                    <Form.Control type="text" value={moment(settings?.tat).format('MMMM Do YYYY, h:mm a')} disabled />
                                </Form.Group>
                                <Form.Group className="mb-3 d-grid" controlId="formBasicEmail">
                                    <DateTimePicker
                                        onChange={onChange}
                                        value={value}
                                        className='b-r-10' />
                                </Form.Group>
                            </div>
                            <div className='d-flex flex-row justify-content-center'>
                                <Button type="submit" className='btn btn-light btn-active-primary' onClick={changeTat} variant="primary" >Submit</Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal> */}
                {/* Manual TAT  Modal Ends*/}

                {/* Manual TAT  Modal Starts*/}


                {/* Manual TAT  Modal Ends*/}
                <Modal show={automationforce} onHide={() => { setAutomationforce(false), automationForceformik.resetForm() }} centered className='manual-tat'>
                    <Modal.Header closeButton>
                        <Modal.Title> Please Provide The Reason</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={automationForceformik.handleSubmit}>
                            <div className=''>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Reason</Form.Label>
                                    <Form.Control
                                        name='reason'
                                        type="text"
                                        autoComplete="false"
                                        // isValid={holdFormik.touched?.reason && !holdFormik.errors?.reason}
                                        isInvalid={!!automationForceformik.errors?.reason}
                                        value={automationForceformik.values?.reason}
                                        className='b-r-10 form-control-solid'
                                        onChange={automationForceformik.handleChange}
                                        // onBlur={revertJobFormik.handleBlur}
                                        // 
                                        placeholder="Reason"
                                    />
                                    <Form.Control.Feedback type="invalid">{automationForceformik.errors?.reason}</Form.Control.Feedback>
                                </Form.Group>

                            </div>
                            <div className='d-flex flex-row justify-content-center'>
                                <Button disabled={automationForceformik.isSubmitting} type="submit" className='btn btn-light btn-active-primary' variant="primary" >Submit</Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                {/* Report History  Modal Starts*/}
                <MyWorkDataEntryReportModal
                    toggleReportPopup={toggleReportPopup}
                    setToggleReportPopup={setToggleReportPopup}
                    reportData={reportData}
                    setReportData={setReportData}
                />

                {/* Report Modal  Modal Ends*/}
                <PlbBulkUpladModal
                    job={currntJob}
                    show={showPlbModal}
                    setShow={setShowPlbModal}
                    setToaster={setToaster}
                />
 {showCheckView &&
    <FileViewerModal
     fileUrl={urlsplittedfile}
      setShowFileView={setShowCheckView}
       showFileView={showCheckView}
    />
}
            </main>

        </React.Fragment>
    )
}

export default AutomationJobMonitor;